import React from 'react'

function LineSVG() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="70%" height="12" viewBox="0 0 719 12" fill="none">
            <path d="M0.666667 6C0.666667 8.94552 3.05448 11.3333 6 11.3333C8.94552 11.3333 11.3333 8.94552 11.3333 6C11.3333 3.05448 8.94552 0.666667 6 0.666667C3.05448 0.666667 0.666667 3.05448 0.666667 6ZM707.667 6C707.667 8.94552 710.055 11.3333 713 11.3333C715.946 11.3333 718.333 8.94552 718.333 6C718.333 3.05448 715.946 0.666667 713 0.666667C710.055 0.666667 707.667 3.05448 707.667 6ZM6 7H713V5H6V7Z" fill="#B7CF33" />
        </svg>
    )
}

export default LineSVG